import {RouteLocationRaw} from "vue-router";

export class UIMenuGroup {
  private _groupData: namaTypes.DTOMenuGroup = {};
  private _subGroups: UIMenuSubGroup[] = [];

  get groupData(): namaTypes.DTOMenuGroup {
    return this._groupData;
  }

  set groupData(value: namaTypes.DTOMenuGroup) {
    this._groupData = value;
  }

  get subGroups(): UIMenuSubGroup[] {
    return this._subGroups;
  }

  set subGroups(value: UIMenuSubGroup[]) {
    this._subGroups = value;
  }
}

export class UIMenuSubGroup {
  private _subGroupData: namaTypes.DTOMenuGroup = {};
  private _subItems: UIMenuItem[] = [];

  constructor() {
  }

  get subGroupData(): namaTypes.DTOMenuGroup {
    return this._subGroupData;
  }

  set subGroupData(value: namaTypes.DTOMenuGroup) {
    this._subGroupData = value;
  }

  get subItems(): UIMenuItem[] {
    return this._subItems;
  }

  set subItems(value: UIMenuItem[]) {
    this._subItems = value;
  }
}

export interface UIMenuItem extends namaTypes.DTOMenuItem {
  searchValue?: string;
  place?: RouteLocationRaw;
}
